import { render, staticRenderFns } from "./Lailusion.vue?vue&type=template&id=5af6329d&scoped=true&"
import script from "./Lailusion.vue?vue&type=script&lang=js&"
export * from "./Lailusion.vue?vue&type=script&lang=js&"
import style0 from "./Lailusion.vue?vue&type=style&index=0&id=5af6329d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af6329d",
  null
  
)

export default component.exports